import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Col, Row, Card, Spinner } from "reactstrap";

// import images
import bgImage from "../../assets/images/wp10581298-data-mining-wallpapers.jpg";
import TrueFocus from "pages/Ui/React-blits/TrueFocus";
import Logo from "../../assets/images/logo.png";
import LogoNew from "../../assets/images/TitleMiner TM.png";

//split text
import SplitText from "pages/Ui/React-blits/SplitText";
import { useForm } from "react-hook-form";

//header
import Header from "components/VerticalLayout/Header";
import { useDispatch } from "react-redux";
import { loginUser } from "store/actions";
import useLogin from "./useLogin";

const OtpLogin = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const{isPending, login} = useLogin();

  //react hook form
  const{register, handleSubmit,formState :{errors},reset,getValues, trigger} = useForm({
    defaultValues:{
      otp:""
    }
  });

  //submit form
  const handleFormSubmit = async (data)=>{
    // e.preventDefault();
    const isValid = await trigger(["otp"]);
    if(isValid){
      // console.log("on handle submit:",data.otp);
      const app_code = data.otp;
      login(app_code)
    }
  }

  document.title = "Login | Title Miner";
  return (
    <React.Fragment>
      <Header/>
      <div className="account-pages" style={{paddingTop:"35px"}}>
        <div className="accountbg"
          style={{
            background: `url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            opacity:"0.9"
          }}>
        </div>

        <div> 
        <Card style={{ height: "90vh", display: "flex", borderRadius:"15px", margin:"40px", borderColor:"black", borderWidth:"1.5px",backgroundImage:`url(${bgImage})`}}>
          <Row style={{height:"100%"}}>
            <Col md={6} style={{ display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center",borderWidth:"10px", borderColor:"black"}}>
              <TrueFocus borderColor="#00ADF0"/>
            </Col>

            <Col md={6}  className="d-flex flex-column justify-content-center align-items-center">
            <div style={{backgroundColor:"white", borderRadius:"10px", width:"90%", height:"90%"}}>
              <div className="text-center mt-4 pt-4">
              <img className="img-fluid" src={LogoNew} alt="TrueFocus Automation" style={{width:"350px"}}/>
            </div>
            
            <p className="text-muted text-center fs-6 pt-2">
              Please enter the app code for login..
            </p>
          <form className="mt-4 p-4 m-4" onSubmit={handleSubmit(handleFormSubmit)}>
              <>
                <div className="mb-3">
              <label htmlFor="otp" className="form-label">App Code</label>
              <input
                type="text"
                className="form-control border-primary-subtle"
                id="otp"
                name="otp"
                placeholder="Code here..."
                // value={otp}
                // onChange={(e)=> setOtp(e.target.value)}
                {...register("otp",{required:"OTP required",
                  minLength:{value:4, message: "OTP must be atleast 4 digits long"},
                  maxLength:{value:10, message: "OTP cannot exceed 10 digits"}
                })}
              />
              { errors.otp && <span className="text-danger">{errors.otp.message}</span>}
            </div>
            <div className="text-start justify-content-center align-items-center" style={{paddingBottom:'5px',borderBottom:'5px'}}>
              Thank you for registering for the free trail. You will be receiving an email shortly to access the Title Miner™ test portal
            </div>
            <button type="submit" className="btn  w-100 py-2" style={{backgroundColor:"#00ADF0", color:"white"}} disabled={isPending}>
              {isPending? <Spinner type="grow" color="secondary" size="sm"/> : "Sign In"}
            </button>
              </>
          </form>
          <div className="text-center mt-2 pt-2 ">
              © {new Date().getFullYear()} TrueFocus Automation.All rights reserved.
          </div>
        </div>
            </Col>
          </Row>
        </Card>
        </div>
      </div>
    </React.Fragment>
  );
};

export default OtpLogin;
